import LegalLink from '@/components/legalLinks/components/legalLink';
import { type Brand } from '@/consts/brands';
import { urls } from '@/utils/urls';

const PrivacyPolicy = ({ brand }: { brand: Brand }) => {
  return (
    <LegalLink
      dataTestId="privacy-policy"
      title="Privacy Policy"
      src={urls[brand].site.legal.privacy}
      type="PrivacyPolicy"
    />
  );
};

export default PrivacyPolicy;
